import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <section id="philosophie" className="py-24 bg-stone-50 dark:bg-navy-950 overflow-hidden transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-stone-900 dark:text-stone-100 mb-6 leading-tight">
              Willkommen bei Vidento, dem Verlag für antiquarische und demographische Titel sowie Kinder- und Jugendbüchern
            </h2>
            <p className="text-2xl font-serif italic text-amber-800 dark:text-amber-400 mb-8">
              Bücher auf den zweiten Blick
            </p>
            <div className="space-y-6 text-stone-700 dark:text-stone-300 leading-relaxed text-lg">
              <p className="font-bold text-stone-900 dark:text-stone-100">
                Schauet! Bücher für alle, die sich Ihre Quellen selber suchen, die in der Lage und willens sind, tiefer zu graben als es die Blase verlangt.
              </p>
              <p>
                Unsere Themenschwerpunkte: Neuere und Zeitgeschichte, Demografie sowie nun auch Kinder- und Jugendliteratur. Im Bereich Neuere und Zeitgeschichte werden wir Autoren vorstellen, deren Werke heute schwer zugänglich sind und es wert sind, wiederentdeckt zu werden.
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="aspect-[4/5] rounded-sm overflow-hidden shadow-2xl">
              <img
                src="/images/about-reading.jpg"
                alt="Vidento Verlag Philosophie"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 w-48 h-48 border-8 border-white dark:border-navy-900 shadow-lg hidden md:block">
              <img
                src="/images/kleiner-mann.jpg"
                alt="Detail"
                className="w-full h-full object-cover"
              />
            </div>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-24">
          {[
             {
              title: 'Antiquarische Titel',
              text: 'Egal ob Rudolf Diesel, Walther Rathenau oder Voltaire – es gibt viele Autoren, die zu vergessen wir uns gar nicht leisten können. Wir bringen diese Stimmen zurück in den Diskurs.'
            },
            {
              title: 'Demografie',
              text: 'Im Bereich Demografie präsentieren wir eine kleine Auswahl an Einführungstiteln, in erster Linie für Sozialwissenschaftler. Praktiker und Jounalisten, aber auch für alle anderen Interessierten.'
            },
            {
              title: 'Werte der Aufklärung',
              text: 'Unsere Bücher für den Nachwuchs sollen nicht nur gut unterhalten, sondern auch die Werte vermitteln, die uns die Aufklärung mitgegeben hat. Nur wer selber denken lernt, kann Freiheit und Verantwortung leben!'
            }

          ].map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="space-y-4"
            >
              <h3 className="text-xl font-serif font-bold text-stone-900 dark:text-stone-100 border-b border-amber-200 dark:border-amber-800 pb-2">
                {item.title}
              </h3>
              <p className="text-stone-600 dark:text-stone-400">{item.text}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="bg-brand dark:bg-navy-800 text-white p-12 md:p-20 text-center relative overflow-hidden rounded-sm"
        >
          <div className="absolute inset-0 opacity-20">
            <img src="/images/hero-books.jpg" alt="Texture" className="w-full h-full object-cover" />
          </div>
          <div className="relative z-10 max-w-3xl mx-auto">
            <h4 className="text-2xl md:text-3xl font-serif italic mb-8 leading-relaxed">
              „Egal ob Rudolf Diesel, Walther Rathenau oder Voltaire – es gibt viele Autoren, die zu vergessen wir uns gar nicht leisten können."
            </h4>
            <div className="w-16 h-1 bg-amber-600 dark:bg-amber-400 mx-auto"></div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
